import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { TargetAudience } from './components/TargetAudience';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Purchase } from './components/Purchase';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      b.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '1252242806993118');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-slate-900 text-slate-50 font-sans selection:bg-cyan-500/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <Solution data-id="element-4" />
        <TargetAudience data-id="element-5" />
        <Bonuses data-id="element-6" />
        <Purchase data-id="element-7" />
        <Testimonials data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <SocialProofPopup data-id="element-10" />

      {/* Global CSS overrides that couldn't fit in index.css easily */}
      <style dangerouslySetInnerHTML={{
      __html: `
        .animate-pulse-slow {
          animation: pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: .95; transform: scale(0.98); }
        }
      `
    }} data-id="element-11" />
    </div>;
}